import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import {
    infinityDateColDef,
    infinityNumberColDef,
    infinityTextColDef,
} from "src/app/utils/aggrid/infinityLoadHelper";

const useActivityGridColumns = () => {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "createdAt",
            ...infinityDateColDef(
                formatMessage({ id: "activity.grid.date" }),
                "createdAt",
                {},
                "DD/MM/YYYY HH:mm:ss"
            ),
            maxWidth: 200,
        },
        {
            field: "author.firstName#author.lastName",
            ...infinityTextColDef(formatMessage({ id: "activity.grid.author" })),
            valueGetter: ({ data }: any) => `${data.author.name}`,
            maxWidth: 200,
        },

        {
            field: "action",
            ...infinityTextColDef(formatMessage({ id: "activity.grid.action" })),
            valueGetter: ({ data }) => formatMessage({ id: `activity.grid.action.${data.action}` }),
            maxWidth: 150,
        },
        {
            field: "objectIdentifier",
            ...infinityTextColDef(formatMessage({ id: "activity.grid.objectIdentifier" })),
            valueGetter: ({ data }) =>
                formatMessage({ id: `activity.grid.objectIdentifier.${data.objectIdentifier}` }),
            maxWidth: 200,
        },
        {
            field: "objectName",
            ...infinityTextColDef(formatMessage({ id: "activity.grid.objectName" })),
        },
        {
            field: "objectId",
            maxWidth: 100,
            ...infinityNumberColDef(formatMessage({ id: "activity.grid.objectId" })),
        },
    ];

    return gridColumns;
};

export default useActivityGridColumns;
